var _g, _path, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreTitleImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 68,
    viewBox: "0 0 261 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18845_2077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 2L11.8369 7.56538L17.0711 4.92893L14.4346 10.1631L20 12L14.4346 13.8369L17.0711 19.0711L11.8369 16.4346L10 22L8.16312 16.4346L2.92893 19.0711L5.56538 13.8369L0 12L5.56538 10.1631L2.92893 4.92893L8.16312 7.56538L10 2Z",
    fill: "#BACE60"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2 18V6.88H35.744V8.368H31.024V11.648H34.704V13.136H31.024V18H29.2ZM37.1684 13.936V6.88H38.9924V13.968C38.9924 15.696 39.9684 16.512 41.5044 16.512C43.0564 16.512 44.0324 15.696 44.0324 13.968V6.88H45.8564V13.936C45.8564 16.768 43.8084 18.112 41.4884 18.112C39.1524 18.112 37.1684 16.768 37.1684 13.936ZM47.9813 6.88H49.8053V16.528H53.5653V18H47.9813V6.88ZM54.8406 6.88H56.6646V16.528H60.4246V18H54.8406V6.88ZM65.6063 18V6.88H67.5743L71.4783 15.6L75.3663 6.88H77.3183V18H75.4943V10.384L72.1023 18H70.8383L67.4303 10.384V18H65.6063ZM90.2176 12.416C90.2176 15.76 87.7056 18.112 84.5376 18.112C81.4016 18.112 78.8576 15.76 78.8576 12.416C78.8576 9.088 81.4016 6.736 84.5376 6.736C87.7056 6.736 90.2176 9.088 90.2176 12.416ZM80.7296 12.416C80.7296 14.928 82.3296 16.528 84.5376 16.528C86.7456 16.528 88.3456 14.928 88.3456 12.416C88.3456 9.904 86.7456 8.336 84.5376 8.336C82.3296 8.336 80.7296 9.904 80.7296 12.416ZM91.7465 13.936V6.88H93.5705V13.968C93.5705 15.696 94.5465 16.512 96.0825 16.512C97.6345 16.512 98.6105 15.696 98.6105 13.968V6.88H100.435V13.936C100.435 16.768 98.3865 18.112 96.0665 18.112C93.7305 18.112 91.7465 16.768 91.7465 13.936ZM101.983 8.368V6.88H109.743V8.368H106.783V18H104.959V8.368H101.983ZM118.397 18V13.136H113.165V18H111.341V6.88H113.165V11.648H118.397V6.88H120.221V18H118.397ZM129.91 6.88C133.478 6.88 135.814 9.04 135.814 12.48C135.814 15.904 133.478 18 129.91 18H126.278V6.88H129.91ZM128.102 16.512H129.91C132.534 16.512 133.942 15.008 133.942 12.48C133.942 9.936 132.534 8.368 129.91 8.368H128.102V16.512ZM143.516 6.864V8.352H139.196V11.616H143.036V13.104H139.196V16.512H143.516V18H137.372V6.864H143.516ZM152.825 6.864H154.649V18H152.825L147.337 9.696V18H145.513V6.864H147.337L152.825 15.152V6.864ZM156.218 8.368V6.88H163.978V8.368H161.018V18H159.194V8.368H156.218ZM173.079 18L172.279 15.728H167.623L166.823 18H164.919L168.903 6.864H171.015L174.999 18H173.079ZM171.767 14.24L169.959 9.072L168.135 14.24H171.767ZM176.481 6.88H178.305V16.528H182.065V18H176.481V6.88ZM187.247 18V6.88H189.071V18H187.247ZM191.216 18V6.88H193.184L197.088 15.6L200.976 6.88H202.928V18H201.104V10.384L197.712 18H196.448L193.04 10.384V18H191.216ZM206.899 12H208.915C210.339 12 210.979 11.312 210.979 10.192C210.979 9.04 210.339 8.368 208.915 8.368H206.899V12ZM212.851 10.192C212.851 11.776 211.811 13.488 208.915 13.488H206.899V18H205.075V6.88H208.915C211.555 6.88 212.851 8.384 212.851 10.192ZM214.341 6.88H216.165V16.528H219.925V18H214.341V6.88ZM228.704 18L227.904 15.728H223.248L222.448 18H220.544L224.528 6.864H226.64L230.624 18H228.704ZM227.392 14.24L225.584 9.072L223.76 14.24H227.392ZM239.418 6.864H241.242V18H239.418L233.93 9.696V18H232.106V6.864H233.93L239.418 15.152V6.864ZM242.812 8.368V6.88H250.572V8.368H247.612V18H245.788V8.368H242.812ZM259.673 14.848C259.673 16.512 258.313 18.112 255.833 18.112C253.609 18.112 251.897 16.896 251.897 14.928H253.849C253.929 15.84 254.569 16.576 255.833 16.576C257.113 16.576 257.833 15.888 257.833 14.944C257.833 12.256 251.929 14 251.929 9.904C251.929 7.952 253.481 6.736 255.753 6.736C257.881 6.736 259.385 7.856 259.545 9.76H257.529C257.465 9.008 256.809 8.32 255.657 8.288C254.601 8.256 253.785 8.768 253.785 9.84C253.785 12.352 259.673 10.784 259.673 14.848Z",
    fill: "#BACE60"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18845_2077)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 137.738,
    y2: -0.5,
    transform: "matrix(-0.957694 0.28779 -0.754358 -0.656463 98.6948 33.1926)",
    stroke: "#BACE60"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 137.738,
    y2: -0.5,
    transform: "matrix(-0.957694 0.28779 -0.754358 -0.656463 99.7617 35.0081)",
    stroke: "#BACE60"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 137.738,
    y2: -0.5,
    transform: "matrix(-0.957694 0.28779 -0.754358 -0.656463 100.828 36.8235)",
    stroke: "#BACE60"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 137.738,
    y2: -0.5,
    transform: "matrix(-0.957694 0.28779 -0.754358 -0.656463 101.895 38.6389)",
    stroke: "#BACE60"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 137.738,
    y2: -0.5,
    transform: "matrix(-0.957694 0.28779 -0.754358 -0.656463 102.962 40.4543)",
    stroke: "#BACE60"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 137.738,
    y2: -0.5,
    transform: "matrix(-0.957694 0.28779 -0.754358 -0.656463 104.029 42.2698)",
    stroke: "#BACE60"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 137.738,
    y2: -0.5,
    transform: "matrix(-0.957694 0.28779 -0.754358 -0.656463 105.096 44.0852)",
    stroke: "#BACE60"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 137.738,
    y2: -0.5,
    transform: "matrix(-0.957694 0.28779 -0.754358 -0.656463 106.163 45.9006)",
    stroke: "#BACE60"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 137.738,
    y2: -0.5,
    transform: "matrix(-0.957694 0.28779 -0.754358 -0.656463 107.229 47.7161)",
    stroke: "#BACE60"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 137.738,
    y2: -0.5,
    transform: "matrix(-0.957694 0.28779 -0.754358 -0.656463 108.296 49.5315)",
    stroke: "#BACE60"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 137.738,
    y2: -0.5,
    transform: "matrix(-0.957694 0.28779 -0.754358 -0.656463 109.363 51.3469)",
    stroke: "#BACE60"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 137.738,
    y2: -0.5,
    transform: "matrix(-0.957694 0.28779 -0.754358 -0.656463 110.43 53.1626)",
    stroke: "#BACE60"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 137.738,
    y2: -0.5,
    transform: "matrix(-0.957694 0.28779 -0.754358 -0.656463 111.497 54.9778)",
    stroke: "#BACE60"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 137.738,
    y2: -0.5,
    transform: "matrix(-0.957694 0.28779 -0.754358 -0.656463 112.563 56.7935)",
    stroke: "#BACE60"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 137.738,
    y2: -0.5,
    transform: "matrix(-0.957694 0.28779 -0.754358 -0.656463 113.63 58.6089)",
    stroke: "#BACE60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18845_2077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18845_2077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 4,
    fill: "white",
    transform: "translate(0 64)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreTitleImg);
export default __webpack_public_path__ + "static/media/preTitleImg.244da8a13d40e2a772f2a77b33117d3e.svg";
export { ForwardRef as ReactComponent };